var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LayoutBase',[_c('div',{staticClass:"page_layout",attrs:{"id":"global-event-listener-div"}},[_c('div',{staticClass:"page_layout--inner container pt-200 pb-100 px-100"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }